const ServerUrl = process.env.API_HOST;
const GameUrl =
  "http://cdn10.cdngoto.com/hamini_0621_1640_release/index.html?channel=";
function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  console.log(query);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return "";
}

//name 字段名
function getCookie(name) {
  if (document.cookie.length > 0) {
    var start = document.cookie.indexOf(name + "=");
    if (start !== -1) {
      start = start + name.length + 1;
      let end = document.cookie.indexOf(";", start);
      if (end === -1) end = document.cookie.length;
      return unescape(document.cookie.substring(start, end));
    }
  }
  return "";
}
function download1() {
  let download_url = ServerUrl + "/api/v1/invite/download-url";
  let inviteCode = getQueryVariable("i");
  download_url = download_url + `?inviteCode=${inviteCode}`;
  var xhr = new XMLHttpRequest();
  xhr.open("GET", download_url, true);
  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4 && xhr.status == 200) {
      var data = JSON.parse(xhr.responseText);
      window.location.href = data.data.downloadUrl;
    }
  };
  xhr.send();
  return;
}
async function download() {
  // return
  let adj_t = getQueryVariable("p0");
  let campaign_name = getQueryVariable("p1");
  let campaign_id = getQueryVariable("p2");
  let adset_name = getQueryVariable("p3");
  let adset_id = getQueryVariable("p4");
  let ad_name = getQueryVariable("p5");
  let ad_id = getQueryVariable("p6");
  let fbpid = getQueryVariable("fbpid");
  let fbclid = getQueryVariable("fbclid");
  let cookpid = getCookie("_fbp");
  let url_host =
    "https://d2k4z7x2ql166o.cloudfront.net/rupeeit/com.rupeeit.app/pkg/rupeeit.apk";
  let download_url = `https://rupeeit.go.link?adj_t=1xq73vir&adj_campaign=${campaign_name}%20%28${campaign_id}%29&adj_adgroup=${adset_name}%20%28${adset_id}%29&adj_creative=${ad_name}%20%28${ad_id}%29&adj_redirect=${url_host}&adj_fbclid=${fbclid}&adj_fbpid=${cookpid}`;
  console.log(download_url);
  window.location.href = download_url;
  return;
}
async function loadPage() {
  chnup("load");
  return;
}

function chnup(event) {
  // return
  let param = {
    action: event,
    chn: "com.rupeeit.app",
  };
  let searchStr = window.location.search;
  var xmlhttp = new XMLHttpRequest();
  xmlhttp.open("POST", ServerUrl + `/cthper/behaviors${searchStr}`, true);

  xmlhttp.send(JSON.stringify(param));
}

function goLoginLimit() {
  let msg = localStorage.getItem("clickTime");
  let nowTime = new Date().valueOf();
  console.log(msg, nowTime);
  if (msg == null || msg == "undefine") {
    console.log("===");
    localStorage.setItem("clickTime", nowTime);
    let url = GameUrl;
    window.location.href = url;
    return;
  }
  let clickTime = parseInt(msg);
  if (nowTime - clickTime < 3000) {
    console.log("time < 3s");
    return;
  }
  localStorage.setItem("clickTime", nowTime);
  let url = GameUrl;
  window.location.href = url;
  return;
}

export { loadPage, chnup, download, getQueryVariable, goLoginLimit };



// WEBPACK FOOTER //
// ./src/utils/tools.js